<template lang='pug'>
  #app(:class="langClass")
    //- MenuTop(ref="menu")
    keep-alive
      router-view(v-if="$route.meta.keepAlive")
    router-view(v-if="!$route.meta.keepAlive")
</template>

<script>
  export default {
    name: 'app',
    computed: {
      langClass(){
        return 'zh_cn' || localStorage.getItem('lang')
      }
    },
    mounted(){},
    methods:{}
  }
</script>
